import { useEffect, useState } from 'react';
import { getCookie } from '../utils/cookieUtils';
import { useNavigate } from 'react-router-dom';
import { authNotAdminAlert } from '../utils/alert/authAlert';


export const useAuthCheck = () => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const navigate = useNavigate();



    useEffect(() => {
        const cookieValue = getCookie('accessToken');
        // const cookieSplit = cookieValue?.split(" ");
        // if (cookieSplit && cookieSplit[0] === 'Bearer' && cookieSplit[1] === 'true') {
        //     alert("this is true!!")
        //     setIsAuthenticated(true);
        // }
        // else {
        //     showWarningAlert();
        //     setIsAuthenticated(false);
        //     navigate("/login")

        // }

    }, [navigate]);
};